import type { PersistConfig } from 'redux-persist'
import { RootState } from '../types'
import createIdbStorage from './idb-storage'

const idbStorage = createIdbStorage('taka-store')

export const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  storage: idbStorage,
  version: 4,
  whitelist: [
    // Core entities
    'userEntities',

    // User state
    'userLimitations',
    'revenueCat',
  ],
  blacklist: [
    // RTK Query caches - always fresh
    'api',

    // Temporary/volatile state
    'authenticationView',
  ],
}
